/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostSavings {
    getFixupPrototypeFunction() { return CostSavings.fixupPrototype; }

    static newInstance(model: Partial<CostSavings>): CostSavings {
        let obj = Object.assign(new CostSavings(), model);
        CostSavings.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostSavings>): CostSavings {
        if (!model) return null;
        return CostSavings.newInstance(<CostSavings> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostSavings) {
        if (!obj) return;

        models.CostSavings.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostSavings): boolean {
        Object.setPrototypeOf(obj, CostSavings.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost === undefined) {
            this.cost = 0;
        }
    }

    /**
     * Charge Unit
     */
    charge_unit: string;

    /**
     * Total cost
     */
    cost: number;

    /**
     * Currency code
     */
    currency_code: string;

}
